import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { SortType } from "@swimlane/ngx-datatable";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar/public-api";
import { BheService } from "src/app/services/bhe.service";
import { PermissionService } from "src/app/services/permission.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import Swal from "sweetalert2";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import * as FileSaver from "file-saver";
import { BoletaHonorariosRecibida } from "src/app/models/BoletaHonorarios/BoletaHonorariosRecibida";
import { BHErecibidaFilter } from "src/app/models/BoletaHonorarios/BHErecibidaFilter";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { ConciliacionRequestBHE } from "src/app/models/BoletaHonorarios/ConciliacionRequestBHE";
import * as _moment from "moment";
import { Moment } from "moment";
import { DateTimeAdapter, OwlDateTimeComponent, OwlDateTimeFormats, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from "ng-pick-datetime";
import { MomentDateTimeAdapter } from "ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { NgbActiveModal, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ConfigMantenedorBhe } from "./config-mantenedor-bhe";
import { EmailBH } from "src/app/models/BoletaHonorarios/EmailBH";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';
const moment = (_moment as any).default ? (_moment as any).default : _moment;

export const MY_MOMENT_DATE_TIME_FORMATS: OwlDateTimeFormats = {
	parseInput: "MM/YYYY",
	fullPickerInput: "l LT",
	datePickerInput: "MM/YYYY",
	timePickerInput: "LT",
	monthYearLabel: "MMM YYYY",
	dateA11yLabel: "LL",
	monthYearA11yLabel: "MMMM YYYY",
};
@Component({
	selector: "app-mantenedor-bhe-recibidas",
	templateUrl: "./mantenedor-bhe-recibidas.component.html",
	styleUrls: ["./mantenedor-bhe-recibidas.component.scss"],
	providers: [
		NgbActiveModal,
		{
			provide: DateTimeAdapter,
			useClass: MomentDateTimeAdapter,
			deps: [OWL_DATE_TIME_LOCALE],
		},
		{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_DATE_TIME_FORMATS },
		{ provide: OWL_DATE_TIME_LOCALE, useValue: "es" },
	],
})
export class MantenedorBheRecibidasComponent implements OnInit {
	@ViewChild("confirmSwal") private confirmSwal: SwalComponent;
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	loading: boolean = false;
	public componentStarted: boolean = false;
	public rowsMantenedor: BoletaHonorariosRecibida[] = [];
	public configScroll: PerfectScrollbarConfigInterface = {};
	public selected: BoletaHonorariosRecibida[] = []; //BHE seleccionadas por checkbox
	public page: Page = new Page();
	public filter: BHErecibidaFilter = new BHErecibidaFilter();
	SortType = SortType;
	public selectedAllItemsInPage: any = {}; // bool para la seleccion total de elementos en tabla
	public conciliacionDate: any = moment();
	private currentEmisorId = this.tokenService.getCompany();
	private currentUsuarioId = this.tokenService.getUser().id;
	public currentModalRef: NgbModalRef;
	public configLocal = ConfigMantenedorBhe;
	public selectedBhe: BoletaHonorariosRecibida;
	public dateConciliacion: any = { startDate: null, endDate: null };
	private modalImportedBheSii: NgbModalRef;
	public validDate: boolean = true;
	public todayString = moment();
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "MM/YYYY",
	};
	public observacionForm: FormGroup;
	constructor(public utilities: UtilitiesService, private bheService: BheService, private ref: ChangeDetectorRef, 
		public permissions: PermissionService, private tokenService: TokenStorageService, private modalService: NgbModal, 
		private sessionUserService: SessionUserService, private formBuilder: FormBuilder) {
		this.filter.emisorID = this.currentEmisorId;
		this.initObservacionForm();
	}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.setPage({ offset: 0 });
	}

	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}

	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		this.bheService.getDataByPageRecibido(this.filter, localPage).subscribe(
			(result) => {
				this.loading = false;
				this.rowsMantenedor = result.data as BoletaHonorariosRecibida[];
				this.ref.detectChanges();
				this.setPagefromResponse(this.page, result);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en lista",
					text: "No fue posible obtener la lista de boletas de honorarios emitidas. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	setPagefromResponse(currentPage: Page, data: PagedResponse<BoletaHonorariosRecibida>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	downloadPDF(boleta: BoletaHonorariosRecibida) {
		this.loading = true;
		this.bheService.getPdfRecibido(boleta).subscribe(
			(result) => {
				this.responseToPdfDownload(result.data, boleta);
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al descargar pdf",
					text: "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	chosenYearHandler(normalizedYear: moment.Moment) {
		let ctrlValue = moment(this.conciliacionDate);
		ctrlValue.year(moment(normalizedYear).year());
		this.conciliacionDate = moment(ctrlValue);
		this.ref.detectChanges();
	}
	chosenMonthHandler(normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment>) {
		let ctrlValue = moment(this.conciliacionDate);
		ctrlValue.month(moment(normalizedMonth).month());
		this.conciliacionDate = moment(ctrlValue);
		this.ref.detectChanges();
		datepicker.close();
	}

	openConciliacionModal(modalRef) {
		this.currentModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	responseToPdfDownload(responseB64, boleta: BoletaHonorariosRecibida) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "application/pdf");
		FileSaver.saveAs(pdfBlob, "boleta_honorarios_n_" + boleta.folio.toString() + "_" + boleta.nombreEmisorBh + ".pdf");
		this.loading = false;
		this.ref.detectChanges();
	}
	onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
	}
	selectAll(event) {
		if (!this.selectedAllItemsInPage[this.page.pageNumber]) {
			if (this.selected.length > 0) {
				this.rowsMantenedor.map((dte) => {
					this.selected = this.selected.filter((selectedDte) => selectedDte.boletaHonorarioId !== dte.boletaHonorarioId);
				});
			}
			this.selected.push(...this.rowsMantenedor);
			this.selected = [...this.selected];
			this.selectedAllItemsInPage[this.page.pageNumber] = true;
		} else {
			this.rowsMantenedor.map((dte) => {
				this.selected = this.selected.filter((selectedDte) => selectedDte.boletaHonorarioId !== dte.boletaHonorarioId);
			});
			this.selectedAllItemsInPage[this.page.pageNumber] = false;
		}
	}
	searchElementsByFilter(event) {
		this.filter.fechaDesde = event.fechaInicio;
		this.filter.fechaHasta = event.fechaFin;
		this.filter[event.criterio] = event.busqueda;
		this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
		this.setPage({ offset: 0 });
	}
	openEnvioCorreoModal(modalRef, row) {
		this.selectedBhe = row;
		this.currentModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}
	closeModal() {
		this.currentModalRef.close();
	}

	sendCorreo(req: EmailBH) {
		req.emisorId = this.currentEmisorId;
		this.loading = true;
		this.bheService.sendEmailBHRecibido(req).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Correo enviado",
					text: "Se envió correctamente el correo con la boleta de honorarios seleccionada",
				});
				this.currentModalRef.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al enviar correo",
					text: "No fue posible enviar correo con la boleta de honorarios seleccionada",
				});
			}
		);
	}

	openDatePickerImportedBhe(modalRef, month: boolean) {
		if (month) this.locale.format = "MM/YYYY";
		else this.locale.format = "DD/MM/YYYY";
		//this.dateConciliacion = null;
		this.dateConciliacion.startDate = moment().startOf("day");
		this.dateConciliacion.endDate = moment().subtract(1, "days").startOf("day");
		this.modalImportedBheSii = this.modalService.open(modalRef, {
			windowClass: "",
			size: "md",
			centered: true,
		});
	}

	importBheSii(conciliacionRequest: NgForm) {
		if (conciliacionRequest.valid && this.validDate) {
			Swal.fire({
				title: "¿Desea importar bhes desde SII?",
				text: "Se buscará y conciliará en el S.I.I los registros de las BHE que hayan sido recibidas.",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Si, importar",
				cancelButtonText: "Cancelar",
			}).then((result) => {
				if (result.isConfirmed) {
					this.loading = true;
					let conciliacion = new ConciliacionRequestBHE();
					conciliacion.emisorId = this.currentEmisorId;
					conciliacion.usuarioId = this.currentUsuarioId;
					if (this.locale.format === "MM/YYYY") {
						const fechaMensual = moment(this.dateConciliacion.startDate, "MM/YYYY").startOf("month");
						conciliacion.fecha = fechaMensual.format("DD/MM/YYYY");
					} else {
						conciliacion.fecha = moment(this.dateConciliacion.startDate).format("DD/MM/YYYY");
					}
					this.bheService.getReceivedDataSii(conciliacion).subscribe(
						(res) => {
							this.loading = false;
							this.ref.detectChanges();
							this.currentSwal.icon = "success";
							this.currentSwal.title = "Importación Exitosa de Bhes desde Sii";
							this.currentSwal.text = "Se importaron correctamente los Bhes desde Sii";
							this.currentSwal.fire();
							this.modalImportedBheSii.close();
							this.setPage({ offset: 0 });
						},
						(err) => {
							this.loading = false;
							this.ref.detectChanges();
							this.currentSwal.icon = "error";
							this.currentSwal.title = "Error al Importar Bhes desde Sii";
							this.currentSwal.text = "No es posible realizar la importación de Bhe desde el sii. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(err.error);
							this.currentSwal.fire();
						}
					);
				}
			});
		}
	}
	detectChangeDate(event) {
		this.validDate = true;
		let fromDate: any;
		if (event.startDate != null) {
			this.dateConciliacion = event;
		} else {
			if (event.target != null && event.target.value != null) {
				this.validDate = moment(event.target.value, this.locale.format, true).isValid();
				if (this.validDate) {
					fromDate = new Object();
					fromDate.startDate = moment(event.target.value, this.locale.format);
					this.dateConciliacion = fromDate;
				}
			}
		}
	}

	openObservacionModal(row: BoletaHonorariosRecibida, modalRef) {
		this.selectedBhe = row;
		this.currentModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}

	initObservacionForm() {
		this.observacionForm = this.formBuilder.group({
			observacion: ['', [Validators.required]]
		});
	}
	
	private getObservacionTexto(valor: string): string {
		const observaciones = {
			'0': 'No se reconoce la relación contractual o comercial con el emisor.',
			'1': 'No se reconoce al emisor de la BHE.'
		};
		return observaciones[valor] || '';
	}

	enviarObservacion() {
		if (this.observacionForm.valid) {
			this.loading = true;
			const valorSeleccionado = this.observacionForm.get('observacion').value;
			const observacionRequest = {
				boletaHonorarioId: this.selectedBhe.boletaHonorarioId,
				emisorId: this.currentEmisorId,
				usuarioId: this.currentUsuarioId,
				observacion: this.getObservacionTexto(valorSeleccionado)
			};
			
			this.bheService.enviarObservacionBhe(observacionRequest).subscribe(
				(result) => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: 'success',
						title: 'Observación enviada',
						text: 'La observación ha sido enviada correctamente al SII'
					});
					this.currentModalRef.close();
					this.setPage({ offset: this.page.pageNumber });
					this.observacionForm.reset();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: 'error',
						title: 'Error al enviar observación',
						text: 'No fue posible enviar la observación. ' + this.utilities.setErrorMessageFromArray(error.error)
					});
				}
			);
		}
	}
	closeObservacionModal() {
		this.currentModalRef.close();
		this.observacionForm.reset();
	}
}
